var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.logo
  }, [_c('logo-large')], 1), _c('div', {
    class: _vm.$style.information
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('quiсk.and.free.registration')))]), _c('p', [_vm._v(_vm._s(_vm.$t('momentaly.activation.simple.integration')))]), _c('p', [_vm._v(_vm._s(_vm.$t('start.to.receive.transfers')))])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }